import { Button, Chip, Icon, Typography } from '@/ui';

import type { PulseCheckEntry } from './types';

interface PulseCheckRowProps {
  entry: PulseCheckEntry;
  onViewClick?: (entry: PulseCheckEntry) => void;
  viewLabel: string;
}

const getDebriefStatusLabel = (entry: PulseCheckEntry) => {
  if (entry.debriefStatus === 'pending') {
    return 'Pending Debrief';
  }
  if (entry.debriefStatus === 'debriefed') {
    return 'Debriefed';
  }
  if (entry.relationshipStage === 'chemistry_only') {
    return 'Chemistry Stage';
  }

  return null;
};

const PulseCheckRow = ({
  entry,
  onViewClick,
  viewLabel,
}: PulseCheckRowProps) => {
  const answeredLabel = `${entry.answeredCount}/${entry.totalQuestions} questions answered`;
  const scoreLabel = `${entry.averageScore.toFixed(1)}/10 average`;
  const statusLabel = getDebriefStatusLabel(entry);
  const showMetrics = entry.suppressMetrics !== true;

  return (
    <div className="space-y-3 py-3">
      <div className="flex items-center justify-between gap-4">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            {entry.isNew && (
              <Chip
                className="h-6 bg-bloom-400 text-cement-500"
                label="New"
                size="small"
              />
            )}
            <Typography className="text-cement-500" variant="subtitle2">
              {entry.dateLabel}
            </Typography>
            {statusLabel && (
              <Chip
                className="h-6 bg-sage-100 text-cement-500"
                label={statusLabel}
                size="small"
              />
            )}
          </div>
          {entry.displayLabel && (
            <Typography className="block text-cement-400" variant="caption">
              {entry.displayLabel}
            </Typography>
          )}
          {showMetrics && (
            <Typography className="text-cement-400" variant="caption">
              {answeredLabel} • {scoreLabel}
            </Typography>
          )}
        </div>

        <Button
          className="min-w-20"
          color="primary"
          size="small"
          variant="contained"
          onClick={() => onViewClick?.(entry)}
        >
          {viewLabel}
        </Button>
      </div>

      {entry.aiSummary && (
        <div className="flex items-start gap-3">
          <Icon className="mt-0.5 text-cement-400">article</Icon>
          <Typography className="text-cement-400" variant="caption">
            {entry.aiSummary}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default PulseCheckRow;
